import { IconWarningAlt } from "@veneer/core";
import React from "react";

interface NoItemsProps {
  text: string;
}

export const NoItems: React.FC<NoItemsProps> = ({ text }) => {
  return (
    <div className="customNoItems">
      <div className="DivIconCustomNoItems">
        <IconWarningAlt className="IconCustomNoItemsOutTable" />
      </div>
      {text}
    </div>
  );
};
